import React from 'react'

const SvgClearFormat = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 17h8a1 1 0 010 2H4a1 1 0 010-2zm4.378-3.004C8.28 14.666 7.904 15 7.25 15c-.654 0-.945-.335-.872-1.004l1.626-10H5.707c-.51-.107-.743-.46-.702-1.056.04-.596.388-.91 1.042-.94h6.183c.544.063.8.393.766.99-.034.596-.36.932-.979 1.006h-2.013l-1.626 10zm6.596.61l2.168 2.169 2.168-2.168c.448-.464.904-.464 1.368 0 .463.463.463.919 0 1.367l-2.169 2.168 2.169 2.168c.455.456.455.912 0 1.368-.456.455-.912.455-1.368 0l-2.168-2.169-2.168 2.169c-.445.466-.901.466-1.367 0-.467-.467-.467-.922 0-1.368l2.168-2.168-2.168-2.168c-.457-.455-.457-.911 0-1.367.456-.457.912-.457 1.367 0v-.001z'
    />
  </svg>
)

export default SvgClearFormat
